export const LOGIN_MESSAGE =
  "Please log in with your Shell credentials to access the Deal Anomaly Tool and start monitoring anomalies in Shell Trades.";
export const LOGIN_BUTTON_TEXT = "Log in with Shell Credentials";
export const LOGIN_HEADING_TEXT = "Deal Anomaly Tool";

// #region Test IDs
export const SHELL_LOGO_TEST_ID = "shell-logo";
export const SHELL_ENERGY_LOGO_TEST_ID = "shell-energy-logo";
